import type { StaticPageListItemDetails, StaticPageListResponse } from '~/types/StaticPageList';

export const useBlogStore = defineStore('blog', {
  actions: {
    async getBlog(page: string | number | null, currentBlogId?: number) {
      try {
        let options = { query: {} as Record<string, string | number | null> };
        if (page) options.query.page = page;
        if (currentBlogId) options.query.currentBlogId = currentBlogId;

        const { data } = await useCustomFetch<StaticPageListResponse>('/info/blog', options);

        if (data.value) {
          return data.value;
        }
      } catch (e) {
        if (e && process.env.NODE_ENV !== 'production') {
          console.error(e);
        }
      }
    },

    async getBlogItemBySlug(slug: string) {
      try {
        const { data } = await useCustomFetch<{ data: StaticPageListItemDetails }>(`/info/blog/${slug}`);

        if (data.value) {
          return data.value.data;
        } else {
          return null;
        }
      } catch (e) {
        if (e && process.env.NODE_ENV !== 'production') {
          console.error(e);
        }
        return null;
      }
    },
  },
});
